import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=152b2dba&scoped=true&"
import script from "./AppSearch.vue?vue&type=script&lang=js&"
export * from "./AppSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b2dba",
  null
  
)

export default component.exports